<div libObserveHeightChanges
    (sizeChanged)="onSizeChange($event)"
    id="ds-main-wrapper"
    animate.enter="ds-fade-enter" animate.leave="ds-fade-leave">
    <ds-slide-host id="ds-slide-displayer" />
    <ds-signage-footer id="ds-footer" />
</div>
